export default "__VITE_ASSET__550aca3e__"